import { render } from "./PaidServicesView.vue?vue&type=template&id=c912b336&scoped=true"
import script from "./PaidServicesView.vue?vue&type=script&lang=js"
export * from "./PaidServicesView.vue?vue&type=script&lang=js"

import "./PaidServicesView.vue?vue&type=style&index=0&id=c912b336&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c912b336"]])

export default __exports__